import { render, staticRenderFns } from "./info-textinfo.vue?vue&type=template&id=2568ee0f&scoped=true&"
import script from "./info-textinfo.vue?vue&type=script&lang=js&"
export * from "./info-textinfo.vue?vue&type=script&lang=js&"
import style0 from "./info-textinfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./info-textinfo.vue?vue&type=style&index=1&id=2568ee0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568ee0f",
  null
  
)

export default component.exports